import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import
{
  Checkbox,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Component } from "react";
import { connect } from "react-redux";
import { confirmAction, showError, showMessage } from "../../actions/uiActions";
import AdministratorsApi from "../../api/administrators";
import DomainsApi from "../../api/domains";
import FileUpload from "../../components/FileUpload";
import AuthorizedEntity from "../../forms/AuthorizedEntity";
import { toBase64 } from "../../utils/Formatter";
import Validators from "../../utils/Validators";
import { withRouter } from "../../utils/withRouter";
import { switchStyle } from "../../utils/styles";
import ConfigurationModal from "../../containers/SsoConfiguration/EditConfigurationModal";

const defaultSplashPageConfig = (slug) => [
  {
    name: "pslf",
    title: "Public Service Loan Forgiveness",
    description:
      "Receive assistance with the Public Service Loan Forgiveness program",
    clickAction: "open_modal",
    steps: [
      {
        title: "Take assessment",
        description:
          "Receive assistance with the Public Service Loan Forgiveness program",
        url: `https://app.peoplejoy.com/${slug}`,
      },
      {
        title: "Log-In",
        description: "Already have an account with PeopleJoy? Click here",
        url: "https://app.ed.peoplejoy.com/auth/login?email=",
      },
    ],
  },
];

const allPaid = [
  { id: 2, value: "Yes", text: "Yes" },
  { id: 3, value: "No", text: "No" },
];

class Domain extends Component
{
  state = {
    coupon: "",
    domain: "",
    name: "",
    company: "",
    isAllPaid: "",
    emails: [],
    domains: [],
    logo: "",
    terms: "",
    add_domain: "",
    add_email: "",
    busy: false,
    codes: [],
    space_id: "",
    subsidy: 0,
    entity: null,
    setEntity: false,
    entities: [],
    allowingAutoMapping: false,
    allowEmployerKey: false,
    requiresEmployerKey: {
      label: "",
      instruction: "",
    },
    admins: [],
    defaultHubspotOwner: "",
    salesHubspotOwner: [],
    logo_name: "",
    terms_name: "",
    enabledSLRA: false,
    dashboardId: "",
    trsDashboardId: "",
    employmentCertificationEmailDisabled: false,
    isClergy: false,
    ssoEnabled: false,
    ssoConfigurations: [],
    showSsoModal: false,
    ssoModalMode: "create",
    chatbotDisabled: false,
  };
  handleInputChange = (e) =>
  {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleEmployerKeyChange = (e, name) =>
  {
    this.setState({
      ...this.state,
      requiresEmployerKey: {
        ...this.state.requiresEmployerKey,
        [name]: e.target.value,
      },
    });
  };
  componentDidMount()
  {
    if (this.props.domain)
    {
      this.setState({
        ...this.props.domain,
        isAllPaid: this.props.domain.isAllPaid ? "Yes" : "No",
        logo: this.props.domain.logo
          ? {
            file: this.props.domain.logo,
            fileName: this.props.domain.logo.split("/")[1],
          }
          : null,
        terms: this.props.domain.terms
          ? {
            file: this.props.domain.terms,
            fileName: this.props.domain.terms.split("/")[1],
          }
          : null,
        allowEmployerKey: !!this.props.domain.requiresEmployerKey,
        entities: this.props.domain.entities || [],
        dashboardId: this.props.domain.dashboardId || "",
        trsDashboardId: this.props.domain.trsDashboardId || "",
        enabledSLRA:
          this.props.domain.services && this.props.domain.services.slra
            ? this.props.domain.services.slra
            : false,
        employmentCertificationEmailDisabled:
          this.props.domain.employmentCertificationEmailDisabled,
        isClergy: !!this.props.domain.isClergy,
        ssoConfigurations: this.props.domain.ssoConfigurations,
        ssoEnabled: this.props.domain.ssoConfigurations?.filter(each => each.status).length > 0,
        chatbotDisabled: this.props.domain.chatbotDisabled || false,
      });
    }
    AdministratorsApi.getList()
      .then((admins) =>
      {
        this.setState({ admins }, (error) => { });
      })
      .catch((error) => { });
  }

  update = async () =>
  {
    let base64logo = "";
    let base64terms = "";

    if (this.state.logo_name)
    {
      base64logo = await toBase64(this.state.logo);
    }
    if (this.state.terms_name)
    {
      base64terms = await toBase64(this.state.terms);
    }

    const response = await DomainsApi.update(this.props.domain._id, {
      coupon: this.state.coupon,
      domain: this.state.domain,
      space_id: this.state.space_id,
      name: this.state.name,
      company: this.state.company,
      isAllPaid: this.state.isAllPaid === "Yes" ? true : false,
      codes: this.state.codes,
      emails: this.state.emails,
      domains: this.state.domains,
      logo: base64logo || "",
      terms: base64terms || "",
      logo_name: this.state.logo_name,
      terms_name: this.state.terms_name,
      newLogo: base64logo ? true : false,
      newTerms: base64terms ? true : false,
      allowingAutoMapping: this.state.allowingAutoMapping,
      subsidy: this.state.subsidy,
      entities: this.state.entities,
      defaultHubspotOwner: this.state.defaultHubspotOwner,
      salesHubspotOwner: this.state.salesHubspotOwner,
      requiresEmployerKey: this.state.allowEmployerKey
        ? this.state.requiresEmployerKey
        : null,
      slra: this.state.enabledSLRA,
      dashboardId: this.state.dashboardId,
      trsDashboardId: this.state.trsDashboardId,
      employmentCertificationEmailDisabled:
        this.state.employmentCertificationEmailDisabled,
      isClergy: this.state.isClergy,
      chatbotDisabled: this.state.chatbotDisabled,
    });
    this.props.onUpdate({...response, ssoConfigurations: this.state.ssoConfigurations});
    this.props.showMessage("The Domain has been updated.");
    this.props.onClose();
  };

  create = async () =>
  {
    let base64logo = "";
    let base64terms = "";

    if (this.state.logo_name)
    {
      base64logo = await toBase64(this.state.logo);
    }
    if (this.state.terms_name)
    {
      base64terms = await toBase64(this.state.terms);
    }

    await DomainsApi.add({
      coupon: this.state.coupon,
      domain: this.state.domain,
      space_id: this.state.space_id,
      name: this.state.name,
      isAllpaid: this.state.isAllPaid === "Yes" ? true : false,
      company: this.state.company,
      codes: this.state.codes,
      emails: this.state.emails,
      domains: this.state.domains,
      logo: base64logo || "",
      terms: base64terms || "",
      logo_name: this.state.logo_name,
      terms_name: this.state.terms_name,
      allowingAutoMapping: this.state.allowingAutoMapping,
      subsidy: this.state.subsidy,
      entities: this.state.entities,
      defaultHubspotOwner: this.state.defaultHubspotOwner,
      salesHubspotOwner: this.state.salesHubspotOwner,
      requiresEmployerKey: this.state.allowEmployerKey
        ? this.state.requiresEmployerKey
        : null,
      slra: this.state.enabledSLRA,
      splashPageConfig: defaultSplashPageConfig(this.state.domain),
      isClergy: this.state.isClergy,
      chatbotDisabled: this.state.chatbotDisabled,
    });
    this.props.onCreate();
    this.props.showMessage("The new Domain has been added.");
    this.props.onClose();
  };

  save = async () =>
  {
    if (!Validators.isAlphaNumeric(this.state.domain))
      this.props.showError(
        "The Company ID can only contain alphanumeric characters.",
      );
    else if (!this.state.name)
      this.props.showError("Please enter the domain description");
    else if (!this.state.company)
      this.props.showError("Please enter the name of the company");
    else if (
      this.state.allowEmployerKey &&
      !this.state.requiresEmployerKey?.label
    )
      this.props.showError("Please enter the label for the Employer Key");
    else
    {
      try
      {
        this.setState({ busy: true });
        if (this.props.domain)
        {
          await this.update();
        } else
        {
          await this.create();
        }
      } catch (error)
      {
        this.props.showError(error);
        if (
          (typeof error === "string" ? error : error?.message)?.includes(
            "subdomain",
          )
        )
        {
          this.props.onCreate();
          this.props.onClose();
        }
      } finally
      {
        this.setState({ busy: false });
      }
    }
  };
  addEmail = () =>
  {
    if (!Validators.isValidEmail(this.state.add_email))
      this.props.showError("Please enter a valid email address.");
    else if (this.state.emails.includes(this.state.add_email.toLowerCase()))
      this.props.showError("The email address has already been added.");
    else
      this.setState({
        emails: [...this.state.emails, this.state.add_email.toLowerCase()],
        add_email: "",
      });
  };
  addCode = () =>
  {
    if (!this.state.add_code)
      this.props.showError("Please enter an authorization code.");
    else if (this.state.codes.includes(this.state.add_code.toUpperCase()))
      this.props.showError("The authorization code has already been added.");
    else
      this.setState({
        codes: [...this.state.codes, this.state.add_code.toUpperCase()],
        add_code: "",
      });
  };
  addDomain = () =>
  {
    if (!Validators.isValidDomain(this.state.add_domain))
      this.props.showError("Please enter a valid domain name.");
    else if (this.state.domains.includes(this.state.add_domain.toLowerCase()))
      this.props.showError("The email domain has already been added.");
    else
      this.setState({
        domains: [...this.state.domains, this.state.add_domain],
        add_domain: "",
      });
  };

  renderEntities = () =>
  {
    return (
      <ul className="entities">
        {this.state.entities.map((entity) => (
          <li key={`entity-${entity.id}`}>
            <div className="row">
              <div className="col-10">
                <label>{entity.employer_name}</label>
              </div>
              <div className="col-2 text-center">
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() =>
                      this.setState({
                        entity,
                        setEntity: true,
                      })
                    }
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton onClick={() => this.removeEntity(entity)}>
                    <Delete />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </li>
        ))}
      </ul>
    );
  };
  removeEntity = (entity) =>
  {
    this.props.confirmAction(
      "You are going to remove this employer from the domain, and all it's associated information. Do you want to proceed?",
      () =>
        this.setState({
          entities: this.state.entities.filter((e) => e.id !== entity.id),
        }),
    );
  };

  getFile = (file, fileName, fieldName) =>
  {
    this.setState({ [fieldName]: file, [fieldName + "_name"]: fileName });
  };

  updateEntity = async (entity) =>
  {
    const response = await DomainsApi.updateEntity(
      this.props.domain._id,
      entity,
    );
    this.props.onUpdate(response);
    this.props.showMessage("The Domain has been updated.");
  };

  fetchSsoConfiguration = async () =>
  {
    try
    {
      const result = await DomainsApi.getSsoConfigurations(
        this.props.domain._id,
        0,
      );
      if (
        result &&
        result.ssoConfigurations &&
        result.ssoConfigurations.length > 0
      )
      {
        const config = result.ssoConfigurations;
        this.setState({
          ssoConfigurations: config,
          ssoEnabled: config.some((conf) => conf.status),
        });
      }
    } catch (error)
    {
      console.error("Error fetching SSO configuration:", error);
    }
  };

  handleSsoToggle = async () =>
  {
    if (this.state.ssoConfigurations.length > 0)
    {
      // Configuration exists, toggle the status
      if (this.state.ssoEnabled)
      {
        // Currently enabled, show confirmation before disabling
        this.props.confirmAction(
          "You are going to disable all SSO configurations for this domain. Users will no longer be able to log in via SSO. Do you want to proceed?",
          async () =>
          {
            try
            {
              await DomainsApi.updateAllSsoConfigurationStatus(
                this.props.domain._id,
                { status: false },
              );
              await this.props.onCreate()
              await this.fetchSsoConfiguration();
              this.props.showMessage("SSO has been disabled");
            } catch (error)
            {
              this.props.showError("Failed to update SSO status");
            }
          },
        );
      } else
      {
        // Currently disabled, enable without confirmation
        try
        {
          await DomainsApi.updateAllSsoConfigurationStatus(
            this.props.domain._id,
            { status: true },
          );
          await this.fetchSsoConfiguration();
          this.props.showMessage("SSO has been enabled");
        } catch (error)
        {
          this.props.showError("Failed to update SSO status");
        }
      }
    } else
    {
      // No configuration exists, open modal to create one
      this.setState({
        showSsoModal: true,
        ssoModalMode: "create",
      });
    }
  };

  handleSsoModalClose = () =>
  {
    this.setState({
      showSsoModal: false,
    });
  };

  handleSsoSaveSuccess = () =>
  {
    this.fetchSsoConfiguration();
    this.handleSsoModalClose();
  };

  handleChatbotToggle = () =>
  {
    this.setState((prevState) => ({
      chatbotDisabled: !prevState.chatbotDisabled,
    }));
  };

  render()
  {
    if (this.state.setEntity)
    {
      return (
        <AuthorizedEntity
          entity={this.state.entity}
          onClose={() => this.setState({ setEntity: false })}
          onEntityCreated={async (entity) =>
          {
            if (
              this.state.entities.find(
                (e) =>
                  e.employer_fein === entity.employer_fein ||
                  e.employer_name === entity.employer_name,
              )
            )
            {
              this.props.showError(
                "There is already an employer in this domain with the same name or FEIN.",
              );
            } else
            {
              await this.updateEntity({
                id: Date.now(),
                ...entity,
              });
              this.setState({
                setEntity: false,
                entities: [
                  ...this.state.entities,
                  {
                    id: Date.now(),
                    ...entity,
                  },
                ],
              });
            }
          }}
          onEntityUpdated={async (entity) =>
          {
            if (
              this.state.entities.find(
                (e) =>
                  (e.employer_fein === entity.employer_fein ||
                    e.employer_name === entity.employer_name) &&
                  e.id !== entity.id,
              )
            )
            {
              this.props.showError(
                "There is already an employer in this domain with the same name or FEIN.",
              );
            } else
            {
              // Should update here
              await this.updateEntity(entity);
              this.setState({
                setEntity: false,
                entities: this.state.entities.map((e) =>
                {
                  if (e.id === entity.id)
                  {
                    return entity;
                  } else
                  {
                    return e;
                  }
                }),
              });
            }
          }}
          edit={this.state.setEntity && !!this.state.entity}
        />
      );
    }
    return (
      <div>
        <div className="row">
          <div className="col-3">
            <div className="form-group nice">
              <label>Company ID</label>
              <input
                disabled={this.state.busy}
                name="domain"
                value={this.state.domain}
                onChange={this.handleInputChange}
                type="text"
                className="form-control"
                placeholder="Company ID (Alphanumeric, Ex: peoplejoy)"
              />
            </div>
          </div>
          <div className="col-4">
            <div className="form-group nice">
              <label>Domain Description</label>
              <input
                disabled={this.state.busy}
                name="name"
                value={this.state.name}
                onChange={this.handleInputChange}
                type="text"
                className="form-control"
                placeholder="Description of the Domain Name for internal use"
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Sales HubSpot Owner</label>
              <Select
                labelId="mutiple-select-label"
                multiple
                name="salesHubspotOwner"
                value={this.state.salesHubspotOwner}
                onChange={this.handleInputChange}
                className="form-control"
                renderValue={(selected) => selected.join(", ")}
              >
                {this.state.admins.map((admin) => (
                  <MenuItem key={admin._id} value={admin.email}>
                    <ListItemIcon>
                      <Checkbox
                        checked={this.state.salesHubspotOwner.includes(
                          admin.email,
                        )}
                      />
                    </ListItemIcon>
                    <ListItemText primary={admin.name} />
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group nice">
              <label>Company Name</label>
              <input
                disabled={this.state.busy}
                name="company"
                value={this.state.company}
                onChange={this.handleInputChange}
                type="text"
                className="form-control"
                placeholder="Company Name"
              />
            </div>
          </div>
          <div className="col-2">
            <div className="form-group nice">
              <label>All Paid</label>
              <Select
                labelId="allPaid"
                name="isAllPaid"
                displayEmpty
                label="Select"
                value={this.state.isAllPaid}
                onChange={this.handleInputChange}
                className="form-control"
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>

                {allPaid.map((paid) => (
                  <MenuItem key={paid.id} value={paid.value}>
                    {paid.text}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Company Logo (optional)</label>
              <FileUpload
                needProccess={true}
                getFile={(file, fileName) =>
                  this.getFile(file, fileName, "logo")
                }
                onError={this.props.showError}
                onUpload={() => { }}
                onChange={(logo) => this.setState({ logo })}
                value={this.state.logo_name}
                disabled={this.state.busy}
                name="file"
                accept=".jpg,.png,.jpeg"
                label="Select Logo..."
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Terms and Conditions (optional)</label>
              <FileUpload
                needProccess={true}
                getFile={(file, fileName) =>
                  this.getFile(file, fileName, "terms")
                }
                onError={this.props.showError}
                onUpload={() => { }}
                onChange={(terms) => this.setState({ terms })}
                value={this.state.terms_name}
                disabled={this.state.busy}
                name="file"
                accept=".pdf, .doc, .docx"
                label="Select file"
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Default Hubspot Owner</label>
              <select
                name="defaultHubspotOwner"
                className="form-control"
                value={this.state.defaultHubspotOwner}
                onChange={this.handleInputChange}
              >
                <option value="">None</option>
                {this.state.admins.map((admin) => (
                  <option key={admin._id} value={admin.email}>
                    {admin.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Confluence Space Id</label>
              <input
                disabled={this.state.busy}
                name="space_id"
                value={this.state.space_id}
                onChange={this.handleInputChange}
                type="text"
                className="form-control"
                placeholder="Confluence Space Id"
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Coupon</label>
              <input
                disabled={this.state.busy}
                name="coupon"
                value={this.state.coupon}
                onChange={this.handleInputChange}
                type="text"
                className="form-control"
                placeholder="Coupon"
              />
            </div>
          </div>
          <div className="col-3">
            <div className="form-group nice">
              <label>Downpayment Subsidy</label>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">$</span>
                </div>
                <input
                  disabled={this.state.busy}
                  name="subsidy"
                  value={this.state.subsidy}
                  onChange={this.handleInputChange}
                  type="number"
                  className="form-control"
                  placeholder="Downpayment Subsidy"
                />
              </div>
            </div>
          </div>
          <div className="row col-12">
            <div className="col-3">
              <div className="form-group nice">
                <label>Advisory Dashboard ID</label>
                <div className="input-group">
                  <input
                    disabled={this.state.busy}
                    name="dashboardId"
                    value={this.state.dashboardId}
                    onChange={this.handleInputChange}
                    type="text"
                    className="form-control"
                    placeholder="Advisory Dashboard"
                  />
                </div>
              </div>
            </div>

            <div className="col-3">
              <div className="form-group nice">
                <label>TRS Dashboard ID</label>
                <div className="input-group">
                  <input
                    disabled={this.state.busy}
                    name="trsDashboardId"
                    value={this.state.trsDashboardId}
                    onChange={this.handleInputChange}
                    type="text"
                    className="form-control"
                    placeholder="TRS Dashboard"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group nice">
              <label>Authorized Email Domains (Optional)</label>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="width80pct">Email Domain</TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.domains.map((domain) => (
                      <TableRow key={domain}>
                        <TableCell>@{domain}</TableCell>
                        <TableCell>
                          <IconButton
                            disabled={this.state.busy}
                            onClick={() =>
                              this.setState({
                                domains: this.state.domains.filter(
                                  (emailDomain) => emailDomain !== domain,
                                ),
                              })
                            }
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell className="inpadding">
                        <div
                          style={{ paddingTop: "5px" }}
                          className="form-group nice"
                        >
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">@</span>
                            </div>
                            <input
                              disabled={this.state.busy}
                              name="add_domain"
                              value={this.state.add_domain}
                              onChange={this.handleInputChange}
                              className="form-control"
                              type="text"
                              placeholder="Email Domain"
                            />
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={this.addDomain}
                          disabled={this.state.busy}
                        >
                          ADD
                        </Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group nice">
              <label>Authorized Email Addresses (Optional)</label>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="width80pct">
                        Email Address
                      </TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.emails.map((email) => (
                      <TableRow key={email}>
                        <TableCell>{email}</TableCell>
                        <TableCell>
                          <IconButton
                            disabled={this.state.busy}
                            onClick={() =>
                              this.setState({
                                emails: this.state.emails.filter(
                                  (emailAddress) => emailAddress !== email,
                                ),
                              })
                            }
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell className="inpadding">
                        <div
                          style={{ paddingTop: "5px" }}
                          className="form-group nice"
                        >
                          <input
                            disabled={this.state.busy}
                            name="add_email"
                            value={this.state.add_email}
                            onChange={this.handleInputChange}
                            className="form-control"
                            type="text"
                            placeholder="Email Address"
                          />
                        </div>
                      </TableCell>
                      <TableCell>
                        <Button onClick={this.addEmail}>ADD</Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </div>
          </div>
          <div className="col-4">
            <div className="form-group nice">
              <label>Authorization Codes (Optional)</label>
              <Paper>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="width80pct">Code</TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.codes.map((code) => (
                      <TableRow key={code}>
                        <TableCell>{code}</TableCell>
                        <TableCell>
                          <IconButton
                            disabled={this.state.busy}
                            onClick={() =>
                              this.setState({
                                codes: this.state.codes.filter(
                                  (authCode) => authCode !== code,
                                ),
                              })
                            }
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell className="inpadding">
                        <div
                          style={{ paddingTop: "5px" }}
                          className="form-group nice"
                        >
                          <input
                            disabled={this.state.busy}
                            name="add_code"
                            value={this.state.add_code}
                            onChange={(e) =>
                            {
                              if (
                                e.target.value === "" ||
                                Validators.isAlphaNumeric(e.target.value)
                              )
                                this.setState({
                                  add_code: e.target.value.toUpperCase(),
                                });
                            }}
                            className="form-control"
                            type="text"
                            placeholder="Code"
                          />
                        </div>
                      </TableCell>
                      <TableCell>
                        <Button onClick={this.addCode}>ADD</Button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </div>
          </div>
          <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.allowEmployerKey}
                  onChange={() =>
                    this.setState({
                      allowEmployerKey: !this.state.allowEmployerKey,
                    })
                  }
                  value="allowEmployerKey"
                  sx={switchStyle}
                />
              }
              label="Enable employer key requirement"
            />
          </div>

          <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={!this.state.employmentCertificationEmailDisabled}
                  onChange={() =>
                  {
                    this.props.confirmAction(
                      this.state.employmentCertificationEmailDisabled
                        ? "You are going to enable employment certifications email notifications. Do you want to proceed?"
                        : "You are going to disable employment certifications email notifications. Do you want to proceed?",
                      () =>
                        this.setState((prevState) => ({
                          employmentCertificationEmailDisabled:
                            !prevState.employmentCertificationEmailDisabled,
                        })),
                    );
                  }}
                  value="employmentCertificationEmailDisabled"
                  sx={switchStyle}
                />
              }
              label="Email Employment Certifications"
            />
          </div>
          {this.state.allowEmployerKey && (
            <div className="row col-12">
              <div className="col-6">
                <div className="form-group nice">
                  <label>Employer key label</label>
                  <input
                    disabled={this.state.busy}
                    name="requiresEmployerKey.label"
                    value={this.state.requiresEmployerKey?.label}
                    onChange={(e) => this.handleEmployerKeyChange(e, "label")}
                    type="text"
                    className="form-control"
                    placeholder="Label text for the Employer Key to show on lead gen"
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group nice">
                  <label>Employer key instruction</label>
                  <input
                    disabled={this.state.busy}
                    name="requiresEmployerKey.instruction"
                    value={this.state.requiresEmployerKey?.instruction}
                    onChange={(e) =>
                      this.handleEmployerKeyChange(e, "instruction")
                    }
                    type="text"
                    className="form-control"
                    placeholder="Instruction text for the Employer Key to show on lead gen"
                  />
                </div>
              </div>
            </div>
          )}

          <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.allowingAutoMapping}
                  onChange={() =>
                    this.setState({
                      allowingAutoMapping: !this.state.allowingAutoMapping,
                    })
                  }
                  sx={switchStyle}
                  value="allowingAutoMapping"
                />
              }
              label="Enable domain auto mapping (PSLF Forms)"
            />
          </div>
          <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.isClergy}
                  onChange={() =>
                    this.setState({ isClergy: !this.state.isClergy })
                  }
                  sx={switchStyle}
                  value="isClergy"
                />
              }
              label="Is Clergy"
            />
          </div>
          <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.enabledSLRA}
                  onChange={() =>
                    this.setState({ enabledSLRA: !this.state.enabledSLRA })
                  }
                  value="slra"
                  sx={switchStyle}
                />
              }
              label="Enable SLRA"
            />
          </div>

          {this.props.domain && <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.ssoEnabled}
                  onChange={this.handleSsoToggle}
                  value="sso"
                  sx={switchStyle}
                />
              }
              label="Enable SSO"
            />
            {!this.state.ssoEnabled && (
              <p
                style={{
                  fontSize: "12px",
                  color: "#666",
                  marginTop: "-8px",
                  marginLeft: "48px",
                }}
              >
                Users for this domain will log in with standard email/password
                (no SSO).
              </p>
            )}
          </div>}

          <div className="col-6">
            <FormControlLabel
              control={
                <Switch
                  checked={!this.state.chatbotDisabled}
                  onChange={this.handleChatbotToggle}
                  value="chatbot"
                  sx={switchStyle}
                />
              }
              label="Enable Chatbot"
            />
          </div>
          <div className="col-12">
            {this.renderEntities()}
            {this.props.domain ? (
              <div className="text-center">
                <button
                  className="link"
                  onClick={() =>
                    this.setState({ setEntity: true, entity: null })
                  }
                >
                  + Add Employer
                </button>
              </div>
            ) : (
              <p className="margin-top-30 flex item-center justify-content-center">
                A domain must be created first to provide the necessary
                information before an entity can be added.
              </p>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12 text-center">
            <div className="line-break" />
            <button
              className="btn btn-primary loading"
              disabled={this.state.busy}
              onClick={this.save}
            >
              {this.props.domain ? "Update Domain Settings" : "Add Domain"}
            </button>
          </div>
        </div>

        {this.state.showSsoModal && (
          <ConfigurationModal
            open={this.state.showSsoModal}
            onClose={this.handleSsoModalClose}
            onSaveSuccess={this.handleSsoSaveSuccess}
            domainId={this.props.domain._id}
            mode={this.state.ssoModalMode}
          />
        )}
      </div>
    );
  }
}
export default withRouter(
  connect(null, { showMessage, showError, confirmAction })(Domain),
);
